var map = {
	"./tds-accordion-item.entry.js": [
		3306,
		3306
	],
	"./tds-accordion.entry.js": [
		3011,
		5392
	],
	"./tds-badge.entry.js": [
		3581,
		3581
	],
	"./tds-banner.entry.js": [
		2182,
		2076,
		2182
	],
	"./tds-block.entry.js": [
		4303,
		4303
	],
	"./tds-body-cell.entry.js": [
		1497,
		1497
	],
	"./tds-breadcrumb.entry.js": [
		6329,
		6329
	],
	"./tds-breadcrumbs.entry.js": [
		1519,
		3900
	],
	"./tds-button.entry.js": [
		5016,
		2076,
		5016
	],
	"./tds-card.entry.js": [
		4102,
		2076,
		4102
	],
	"./tds-checkbox.entry.js": [
		7245,
		2076,
		7245
	],
	"./tds-chip.entry.js": [
		6814,
		2076,
		6814
	],
	"./tds-core-header-item_2.entry.js": [
		944,
		2076,
		944
	],
	"./tds-datetime.entry.js": [
		389,
		389
	],
	"./tds-divider.entry.js": [
		9515,
		9515
	],
	"./tds-dropdown-option.entry.js": [
		8255,
		8255
	],
	"./tds-dropdown.entry.js": [
		2141,
		2141
	],
	"./tds-folder-tab.entry.js": [
		518,
		518
	],
	"./tds-folder-tabs.entry.js": [
		6785,
		6785
	],
	"./tds-footer-group.entry.js": [
		5257,
		5257
	],
	"./tds-footer-item.entry.js": [
		7755,
		7755
	],
	"./tds-footer.entry.js": [
		5567,
		2076,
		5567
	],
	"./tds-header-brand-symbol.entry.js": [
		1878,
		1878
	],
	"./tds-header-cell.entry.js": [
		4178,
		4178
	],
	"./tds-header-dropdown-list-item.entry.js": [
		2286,
		2286
	],
	"./tds-header-dropdown-list-user.entry.js": [
		8466,
		8466
	],
	"./tds-header-dropdown-list.entry.js": [
		7308,
		2076,
		7308
	],
	"./tds-header-dropdown.entry.js": [
		4491,
		2076,
		4491
	],
	"./tds-header-hamburger.entry.js": [
		5451,
		2076,
		5451
	],
	"./tds-header-launcher-button.entry.js": [
		4739,
		2076,
		4739
	],
	"./tds-header-launcher-grid-item.entry.js": [
		3079,
		3079
	],
	"./tds-header-launcher-grid-title.entry.js": [
		1404,
		2076,
		1404
	],
	"./tds-header-launcher-grid.entry.js": [
		4915,
		2076,
		4915
	],
	"./tds-header-launcher-list-item.entry.js": [
		5659,
		5659
	],
	"./tds-header-launcher-list-title.entry.js": [
		5888,
		2076,
		5888
	],
	"./tds-header-launcher-list.entry.js": [
		1647,
		2076,
		1647
	],
	"./tds-header-launcher.entry.js": [
		4534,
		2076,
		4534
	],
	"./tds-header-title.entry.js": [
		1918,
		1918
	],
	"./tds-header.entry.js": [
		8141,
		2076,
		8141
	],
	"./tds-icon.entry.js": [
		9941,
		9941
	],
	"./tds-inline-tab.entry.js": [
		7831,
		7831
	],
	"./tds-inline-tabs.entry.js": [
		7138,
		7138
	],
	"./tds-link.entry.js": [
		2424,
		2424
	],
	"./tds-message.entry.js": [
		8121,
		8121
	],
	"./tds-modal.entry.js": [
		5523,
		2076,
		5523
	],
	"./tds-navigation-tab.entry.js": [
		9144,
		9144
	],
	"./tds-navigation-tabs.entry.js": [
		5011,
		5011
	],
	"./tds-popover-canvas.entry.js": [
		4488,
		2076,
		4488
	],
	"./tds-popover-core.entry.js": [
		1984,
		2076,
		9603
	],
	"./tds-popover-menu-item.entry.js": [
		4819,
		4819
	],
	"./tds-popover-menu.entry.js": [
		1927,
		2076,
		1927
	],
	"./tds-radio-button.entry.js": [
		2826,
		2076,
		2826
	],
	"./tds-side-menu-close-button.entry.js": [
		4323,
		2076,
		4323
	],
	"./tds-side-menu-collapse-button.entry.js": [
		160,
		160
	],
	"./tds-side-menu-dropdown-list-item.entry.js": [
		32,
		32
	],
	"./tds-side-menu-dropdown-list.entry.js": [
		1138,
		1138
	],
	"./tds-side-menu-dropdown.entry.js": [
		1225,
		1225
	],
	"./tds-side-menu-item.entry.js": [
		7855,
		2076,
		7855
	],
	"./tds-side-menu-overlay.entry.js": [
		5702,
		5702
	],
	"./tds-side-menu-user-image_2.entry.js": [
		7962,
		7962
	],
	"./tds-side-menu-user.entry.js": [
		4483,
		4483
	],
	"./tds-side-menu.entry.js": [
		4811,
		4811
	],
	"./tds-slider.entry.js": [
		8161,
		2076,
		8161
	],
	"./tds-spinner.entry.js": [
		2035,
		2035
	],
	"./tds-step.entry.js": [
		5342,
		5342
	],
	"./tds-stepper.entry.js": [
		7611,
		2076,
		7611
	],
	"./tds-table-body-row-expandable.entry.js": [
		8399,
		2076,
		8399
	],
	"./tds-table-body-row.entry.js": [
		4618,
		4618
	],
	"./tds-table-body.entry.js": [
		6031,
		6031
	],
	"./tds-table-footer.entry.js": [
		3067,
		5448
	],
	"./tds-table-header.entry.js": [
		1166,
		1166
	],
	"./tds-table-toolbar.entry.js": [
		452,
		452
	],
	"./tds-table.entry.js": [
		8238,
		2076,
		8238
	],
	"./tds-text-field.entry.js": [
		7418,
		2076,
		7418
	],
	"./tds-textarea.entry.js": [
		6690,
		6690
	],
	"./tds-toast.entry.js": [
		5333,
		2076,
		5333
	],
	"./tds-toggle.entry.js": [
		2876,
		2076,
		2876
	],
	"./tds-tooltip.entry.js": [
		1845,
		2076,
		1845
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 928;
module.exports = webpackAsyncContext;